import { render, staticRenderFns } from "./StandaloneRating.vue?vue&type=template&id=34918a89&scoped=true&"
import script from "./StandaloneRating.vue?vue&type=script&lang=js&"
export * from "./StandaloneRating.vue?vue&type=script&lang=js&"
import style0 from "./StandaloneRating.vue?vue&type=style&index=0&id=34918a89&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34918a89",
  null
  
)

export default component.exports